import type { ReactElement } from 'react';
import { GraphToolbarButton } from '../Cmarkdowngraphcontrols';
const SVG_STROKE_VALUE = {
    CurrentColor: 'currentColor',
    Round: 'round',
} as const;
const MINIMAP_BUTTON_ICON = 'mindmapToolbarButtonIcon';
const MINIMAP_BUTTON_FRAME = 'mindmapToolbarButtonFrame';
const MINIMAP_TOOLBAR_PATH = 'mindmapToolbarButtonPath';
const MINIMAP_INNER_CHEVRON_TOP_PATH_ID = 'inner-chevron-top';
const MINIMAP_INNER_CHEVRON_BOTTOM_PATH_ID = 'inner-chevron-bottom';
const MINIMAP_OUTER_CHEVRON_TOP_PATH_ID = 'outer-chevron-top';
const MINIMAP_OUTER_CHEVRON_BOTTOM_PATH_ID = 'outer-chevron-bottom';
const MINIMAP_TOP_LEFT_PATH_ID = 'top-left';
const MINIMAP_TOP_RIGHT_PATH_ID = 'top-right';
const MINIMAP_BOTTOM_LEFT_PATH_ID = 'bottom-left';
const MINIMAP_BOTTOM_RIGHT_PATH_ID = 'bottom-right';
interface MindmapControlButtonsProps {
    isFocusDisabled: boolean;
    onCollapseAll: () => void;
    onExpandAll: () => void;
    onFocusTree: () => void;
}
export function MindmapControlButtons({ isFocusDisabled, onCollapseAll, onExpandAll, onFocusTree, }: MindmapControlButtonsProps): ReactElement {
    return (<>
      <GraphToolbarButton onClick={onCollapseAll} disabled={false} label="Collapse all">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <rect x={1} y={1} width={12} height={12} rx={2} stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2}/>
          <path d="M3.8 9.2L7 6L10.2 9.2" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M3.8 7.2L7 4L10.2 7.2" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
        </svg>
      </GraphToolbarButton>
      <GraphToolbarButton onClick={onFocusTree} disabled={isFocusDisabled} label="Focus tree">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M5 1.5H1.5V5" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M9 1.5H12.5V5" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M5 12.5H1.5V9" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M9 12.5H12.5V9" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
        </svg>
      </GraphToolbarButton>
      <GraphToolbarButton onClick={onExpandAll} disabled={false} label="Expand all">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <rect x={1} y={1} width={12} height={12} rx={2} stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2}/>
          <path d="M3.8 4.8L7 8L10.2 4.8" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M3.8 6.8L7 10L10.2 6.8" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
        </svg>
      </GraphToolbarButton>
    </>);
}
